export default __webpack_public_path__ + "static/media/iphone-xr.baf8cc4e.png";